<template>
  <div class="poster-list">
    <template>
      <div style="min-height: 400px;margin-bottom:20px;">
        <Row :gutter="30">
          <Col
            :sm="12"
            :md="6"
            v-for="(item, index) in list"
            :key="'act-' + index"
            class="w-20"
          >
          <div class="poster-list-one">
            <div class="poster-imgbox">
              <img :src="item">
              <!-- <img src="@/assets/img/empty.png" v-else /> -->
            </div>
            <div class="poster-btn">
              <div class="txt" @click="open(item)" style="color: #1890ff;">开启</div>
              <div class="poster-btn-line"></div>
              <div class="txt" @click="edit(item)">编辑</div>
            </div>
          </div>
          </Col>
        </Row>

        <div class="my-page" v-if="totalCount > pageSize" style="text-align:center;">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
    </template>
    <!-- <div v-else style="line-height:500px;text-align:center;">暂无数据</div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "host-poster-exsupply",
  props: {
    search: {
      type: String,
      default() {
        return "";
      }
    }
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  data() {
    return {
      list: [
        "http://exshow.oss-cn-shanghai.aliyuncs.com/exshow/imgs/201907/5cc2c7a95b704bac89473f938e525c76.png?x-oss-process=style/ex_pc_banner",
        "http://exshow.oss-cn-shanghai.aliyuncs.com/exshow/imgs/201907/5cc2c7a95b704bac89473f938e525c76.png?x-oss-process=style/ex_pc_banner",
        "http://exshow.oss-cn-shanghai.aliyuncs.com/exshow/imgs/201907/5cc2c7a95b704bac89473f938e525c76.png?x-oss-process=style/ex_pc_banner",
        "http://exshow.oss-cn-shanghai.aliyuncs.com/exshow/imgs/201907/5cc2c7a95b704bac89473f938e525c76.png?x-oss-process=style/ex_pc_banner",
      ],
      pageIndex: 1,
      pageSize: 12,
      totalCount: 0,
      show: false,
    }
  },
  methods: {
    ...mapActions({
      getActByExId: "hostActModule/getActByExId",
    }),
    async init() {
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    linkTo(item) {
    },
    async open(item) {
    },
    async edit(item) {
      this.$router.push({
        path: '/host/index/common/common-poster-edit',
        query: {
          id: "111"
        }
      })
    },
    async delItem(item) {
    },
  },
  created() {
    this.init();
  }
}
</script>

<style lang="scss" scoped>
.poster-list {
  min-width: 1000px;
  padding: 30px 30px 100px 30px;
  &-one {
    background-color: #fff;
    margin-bottom: 20px;
    .poster-imgbox {
      width: 100%;
      height: 400px;
      position: relative;
      img {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-height: 100%;
      }
    }
    .poster-btn {
      font-size: 14px;
      height: 48px;
      text-align: center;
      color: #808080;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .txt {
        width: 50%;
      }
      &-line {
        display: inline-block;
        width: 1px;
        height: 30px;
        background-color: #e8e8e8;
        padding-top: 18px;
      }
    }
  }
}
</style>
<style lang="scss">
.vertical-center-modal{
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal{
      top: 0;
  }
}
</style>